import JackpotTicker from 'containers/JackpotsFromProviders/JackpotTicker'
import type { JackpotCurrency } from 'store/modules/jackpotsFromProviders/types'

export type BingoJackpotTickerProps = {
  amount: number
  currency: JackpotCurrency
  className?: string
}

export default function BingoJackpotTicker({ amount, currency, className }: BingoJackpotTickerProps) {
  return <JackpotTicker amount={amount} currency={currency} className={className} formatMode='compactMillions' />
}
